import { render, staticRenderFns } from "./DisableAccountConfirmation.vue?vue&type=template&id=c57e4066"
import script from "./DisableAccountConfirmation.vue?vue&type=script&lang=js"
export * from "./DisableAccountConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports